import { Field, Dropdown } from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import { createYesNoOptions } from '@/config/formOptions';

// A declaration's optional voluntary add-on certifications (FSS, EUDR, Non-GMO).

const yesNoOptions = createYesNoOptions({ yes: true, no: false });

const ADD_ON_FIELDS = [
  ['foodSecurityStandard', 'FORM_FOOD_SECURITY_STANDARD'],
  ['euDeforestationRegulation', 'FORM_EU_DEFORESTATION_REGULATION'],
  ['nonGmoFoodAndFeed', 'FORM_NON_GMO_FOOD_FEED'],
  ['nonGmoTechnicalMarkets', 'FORM_NON_GMO_TECHNICAL_MARKETS'],
];

/**
 * Props:
 *   field  one of ADD_ON_FIELDS' names — which voluntary add-on this renders
 */
export const VoluntaryAddOnField = ({ field }) => {
  const t = useTranslations();
  const entry = ADD_ON_FIELDS.find(([name]) => name === field);

  return (
    <Field name={entry[0]}>
      {({ id, name, value, onChange, onBlur, status, message }) => (
        <Dropdown
          id={id}
          name={name}
          label={t(entry[1])}
          placeholder={t('COMMON_SELECT')}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
          options={yesNoOptions(t)}
        />
      )}
    </Field>
  );
};
